// extracted by mini-css-extract-plugin
module.exports = {"element":"form_element__YQJXe","heading":"form_heading__bSZPA","text":"form_text__2dp2W","inner":"form_inner__1btR5","form":"form_form__3j8lY"};